/**
 * Image Protection Script
 * Prevents casual image theft while maintaining good UX
 * Does NOT disable right-click site-wide (annoying), only on protected images
 */

(function() {
  'use strict';

  // Selectors for images we want to protect
  const protectedSelectors = [
    '.product__media img',
    '.gallery-grid__image',
    '.guide-profile__product-img',
    '.product-media-modal__content img',
    '.print-configurator__main-image',
    '.print-configurator__image',
    '.card__media img',
    '.banner__media img',
    '[data-protected-image]'
  ];

  // Disable context menu on protected images only
  document.addEventListener('contextmenu', function(e) {
    const target = e.target;

    // Check if the clicked element matches any protected selector
    const isProtected = protectedSelectors.some(selector => {
      return target.matches(selector) || target.closest(selector);
    });

    if (isProtected) {
      e.preventDefault();
      return false;
    }
  });

  // Disable drag on protected images
  document.addEventListener('dragstart', function(e) {
    if (e.target.tagName === 'IMG') {
      const isProtected = protectedSelectors.some(selector => {
        return e.target.matches(selector) || e.target.closest(selector);
      });

      if (isProtected) {
        e.preventDefault();
        return false;
      }
    }
  });

  // Disable keyboard shortcuts for saving (Ctrl+S, Cmd+S) on product pages
  document.addEventListener('keydown', function(e) {
    // Only block on product pages
    if (!document.querySelector('.product__media')) return;

    if ((e.ctrlKey || e.metaKey) && e.key === 's') {
      e.preventDefault();
      return false;
    }
  });
})();
